import React from "react";

function NotFound() {
    return ( 
        <>
        <h2>404 page not Found</h2>
        <p>Move to the home page</p>
        </>
     );
}

export default NotFound;